// extracted by mini-css-extract-plugin
module.exports = {"grid":"SubgroupForm_grid__qZcQx","input":"SubgroupForm_input__3Pr_s","actions":"SubgroupForm_actions__2_M6r"};